module.exports = __webpack_public_path__ + "static/media/LoopCard.5c5cff16.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/ChallengeCards/LoopCard.PNG
// module id = 1049
// module chunks = 0